// Окно входа, вызванное из любого места приложения (`requestSignIn`).
//
// Живёт отдельным узлом, а не внутри AuthProvider: провайдер, импортирующий
// модал, который импортирует провайдера, — цикл, который до поры работает,
// а потом ломается при смене порядка модулей в сборке.
import type { ReactElement } from 'react';
import { useAuth } from './AuthProvider';
import { AuthModal } from './AuthModal';

export function AuthGate(): ReactElement | null {
  const { signInRequested, dismissSignIn } = useAuth();
  if (!signInRequested) return null;
  return <AuthModal onClose={dismissSignIn} />;
}
